import React, { useState } from "react";
import Footer from "../containers/Footer/index";
import Sidebar from "../components/Sidebar/SideBar";
import Header from "../components/Header/index";

export default function Layout({ children }: { children: any }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex bg-gray-50" style={{ height: "100dvh" }}>
            <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />


            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            <div className="flex flex-col flex-1 min-w-0 overflow-y-auto">
                {/* Header */}
                <header className="flex-shrink-0 z-10 bg-white border-b sticky top-0">
                    <Header onMenuClick={() => setSidebarOpen(true)} />
                </header>

                <main className="flex-1 bg-neutral-100 px-2 lg:px-6 py-6">
                    {children}
                </main>

                <footer className="flex-shrink-0">
                    <Footer />
                </footer>
            </div>
        </div>
    );
}